<template>
  <div
    :class="{ 'has-logo': showLogo }"
    :style="{ backgroundColor: settings.sideTheme === 'theme-dark' ? variables.menuBackground : variables.menuLightBackground }"
  >
    <logo :collapse="isCollapse" />
    <el-scrollbar :class="settings.sideTheme" wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="settings.sideTheme === 'theme-dark' ? variables.menuBackground : variables.menuLightBackground"
        :text-color="settings.sideTheme === 'theme-dark' ? variables.menuColor : variables.menuLightColor"
        :unique-opened="true"
        :active-text-color="settings.theme"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="(route, index) in sidebarRouters"
          :key="route.path + index"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/assets/styles/variables.module.scss";
import { getUserInfo, getAuthInfo } from "@/utils/auth";
import { routes } from "@/router";
import { deepClone } from "@/utils/tool";
export default {
  components: { Logo, SidebarItem },
  data() {
    const _routes = deepClone(routes);
    let userId = localStorage.getItem("userId");
    let authInfo = getAuthInfo();
    
    if (!["38717", "8860"].includes(userId)) {
      //只有岷山,德信显示财务管理-资金调拨
      _routes.forEach(item => {
        if (item.name == "MoneyManagement") {
          let children = item.children;
          let index = children.findIndex(t => t.name == "finaceChange");
          children.splice(index, 1); //删除资金调拨菜单项
        }
      });
    }
    if (authInfo.is_real_money == 1) {
      //设置了不显示实结金额
      _routes.forEach(item => {
        if (item.name == "MoneyManagement") {
          let children = item.children;
          let index = children.findIndex(t => t.name == "payValidate");
          children.splice(index, 1); //删除支付结果验证菜单项
        }
      });
    }
    return {
      sidebarRouters: _routes
    };
  },
  mounted() {
    let userInfo = getUserInfo();
    if (userInfo.id && userInfo.id == 38717) {
      this.sidebarRouters[4].children.push({
        path: "moneyRecord",
        component: "moneyManagement/moneyRecord",
        meta: {
          title: "充值记录",
          icon: "moneyRecord",
          noCache: false,
          link: null
        }
      });
    }
  },
  computed: {
    ...mapState(["settings"]),
    ...mapGetters(["sidebar"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  }
};
</script>


<style lang="scss" scoped>
::v-deep .el-scrollbar ::-webkit-scrollbar {
  width: 0 !important;
}
</style>
